import React from 'react';
import classNames from 'classnames';

interface Props {
  fixedWidth?: boolean;
  icon?: string;
  loading?: boolean;
  className?: string;
  onClick?: () => void;
}

const Icon = ({ fixedWidth, icon, loading, className, onClick }: Props) => {
  if (!icon && loading === undefined) {
    throw new Error('Icon component must have either an icon or loading prop');
  }

  return (
    <i
      onClick={onClick}
      className={classNames('fa-solid', loading ? 'fa-spinner-third' : `fa-${icon}`, className, {
        'fa-spin': loading,
        'cursor-pointer': onClick,
        'fa-fw': fixedWidth
      })}
    />
  );
};

export default Icon;
